import { useFormContext } from 'react-hook-form';
import { InputCheckbox } from '../../../../forms/';
import { FormDataApis, OptionCheckbox } from '../../ApisForm.model';
import { UseCheckBoxInfo } from '../../hooks/UseCheckBoxInfo';
import styles from './CheckBoxInfo.module.css';

export const CheckBoxInfo = () => {
	const { register } = useFormContext<FormDataApis>();
	const { t, isFormDisabled, arrInputs, DialogLink, getLabel } = UseCheckBoxInfo();

	return (
		<div className={styles.box_container}>
			{arrInputs.map(({ name, label, className, required, i18nTrans = false }: OptionCheckbox) => {
				return (
					<InputCheckbox
						key={name}
						{...register(name, {
							required: required ? t('CHECK_REQUIRED_ERROR') : undefined
						})}
						name={name}
						label={getLabel(i18nTrans, label)}
						className={styles[className]}
						disabled={isFormDisabled}
					/>
				);
			})}
			{DialogLink()}
		</div>
	);
};
CheckBoxInfo.displayName = 'CheckBoxInfo';
